<template>
  <div class="dialog_box">
    <el-dialog title="新增企业" :visible="show" width="800px" @close="dialogClose" top="10vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <el-form ref="form" class="form_box" :model="form" label-width="140px" :rules="rules">
          <div class="module_box">
            <div class="form_title">基本信息</div>
            <el-form-item label="企业名称" prop="orgName">
              <el-input v-model="form.orgName" placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item label="企业简介">
              <el-input v-model="form.orgSimpleName" placeholder="请输入企业简称"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" label-width="140px" prop="contactsName">
              <el-input v-model="form.creditCode" placeholder="请输入统一社会信用代码"></el-input>
            </el-form-item>
            <el-form-item label="企业负责人" prop="head">
              <el-input v-model="form.head" placeholder="请输入企业负责人"></el-input>
            </el-form-item>
            <el-form-item label="所属区域" prop="areaId">
              <el-cascader placeholder="请选择所在区域" v-model="form.areaId" :options="areaTree" :props="optionProps"
                :filterable="true" :emitPath="false" :show-all-levels="true" @change="cascaderChange"
                ref="cascader"></el-cascader>
            </el-form-item>
            <el-form-item label="负责人手机号" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入负责人手机号"></el-input>
            </el-form-item>
            <el-form-item label="详细地址" prop="addr">
              <el-input v-model="form.addr" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </div>

          <div class="module_box">
            <div class="form_title">车辆/终端信息</div>
            <el-form-item label="车辆总数">
              <el-input v-model="form.carNum" placeholder="请输入车辆总数"></el-input>
            </el-form-item>
            <el-form-item label="终端总数">
              <el-input v-model="form.terNum" placeholder="请输入终端总数"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      form: {
        addr: "",
        areaId: null,
        areaName: "",
        carNum: null,
        creditCode: "",
        head: "",
        orgName: "",
        orgSimpleName: "",
        phone: "",
        terNum: null,
        id: null
      },
      rules: {
        orgName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        orgSimpleName: [
          { required: true, message: "请输入企业简称", trigger: "blur" },
        ],
        head: [
          { required: true, message: "请输入企业负责人", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
        addr: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        areaId: [
          { required: true, message: "请选择所在区域", trigger: "change" },
        ],
      },
      areaTree: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
      },
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {}
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.form = {
          addr: this.data.addr,
          areaId: this.data.areaId + '',
          areaName: this.data.areaName,
          carNum: this.data.carNum,
          creditCode: this.data.creditCode,
          head: this.data.head,
          orgName: this.data.orgName,
          orgSimpleName: this.data.orgSimpleName,
          phone: this.data.phone,
          terNum: this.data.terNum,
          id: this.data.id
        }
        this.$http.areaTree({ isTree: true }).then((res) => {
          if (res.code === 0) {
            this.areaTree = res.data;
          } else {
            this.areaTree = [];
          }
        });
      }
    },
  },
  created () { },
  methods: {
    cascaderChange (value) {
      console.log(value);
      let name1 = "";
      let name2 = "";
      let name3 = "";
      this.areaTree.forEach((a) => {
        if (a.children && a.children.length > 0) {
          a.children.forEach((b) => {
            if (b.children && b.children.length > 0) {
              b.children.forEach((c) => {
                if (c.id == value) {
                  name3 = c.name;
                  if (c.parentId == b.id) {
                    name2 = b.name;
                    if (b.parentId == a.id) {
                      name1 = a.name;
                    }
                  }
                }
              });
            }
          });
        }
      });
      let address = `${name1}/${name2}/${name3}`;
      this.form.areaName = address;
    },
    dialogClose () {
      this.form = {
        addr: "",
        areaId: null,
        areaName: "",
        carNum: null,
        creditCode: "",
        head: "",
        orgName: "",
        orgSimpleName: "",
        phone: "",
        terNum: null
      };
      this.$emit("update:show", false);
    },
    confirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.$http.updateOrg(this.form).then((res) => {
          if (res.code === 0) {
            // this.$message.success(res.msg);
            this.form = {};
            this.$parent.getList();
            this.$emit("update:show", false);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

.map_box {
  width: 350px;
  height: 53px;
  display: flex;
  justify-content: space-between;

  .map_btn {
    cursor: pointer;
    background-color: #255a7e;
    width: 53px;
    height: 28px;
    display: flex;
    border-radius: 5px;
    font-size: 16px;
    justify-content: center;
    align-items: center;
    color: #fff;
  }

  .map_img {
    width: 290px;
    height: 90px;
  }
}

/deep/.el-input {
  width: 220px !important;

  .el-input__inner {
    width: 220px !important;
    padding-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/company_Admin/component/redact.vue